import React from 'react';
import TextInput from '../../form/TextInput';
import Select from '../../form/Select';
import createForm from "./Form";
import {CurrencyFormatter} from "../../../utils/formatters";

class ProgramPriceForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-md-2">
                        <TextInput
                            name={this.props.componentConfig.idfield}
                            value={this.props.values[this.props.componentConfig.idfield]}
                            label="Kód"
                            role="idfield"
                            {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                        />
                    </div>
                    <div className="col-md-2">
                        <Select
                            component="Program"
                            name="program"
                            value={this.props.values.program}
                            label="Program"
                            labelKey="name"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("program")}
                        />
                    </div>
                    <div className="col-md-2 currency">
                        <TextInput
                            name="price"
                            type="number"
                            value={this.props.values.price}
                            label="Ár"
                            formatter={CurrencyFormatter}
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("price")}
                        />
                    </div>
                    <div className="col-md-2 currency">
                        <TextInput
                            name="group_price"
                            type="number"
                            value={this.props.values.group_price}
                            label="Csoportos ár"
                            formatter={CurrencyFormatter}
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("group_price")}
                        />
                    </div>
                    <div className="col-md-2">
                        <TextInput
                            name="limit"
                            type="number"
                            value={this.props.values.limit}
                            label="x Fő-től"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("limit")}
                        />
                    </div>
                    <div className="col-md-2">
                        <Select
                            component="currency"
                            name="currency"
                            storeType="local"
                            autoSelect={true}
                            value={this.props.values.currency}
                            label="Pénznem"
                            labelKey="name"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("currency")}
                        />
                    </div>
                    {/*<div className="col-md-8">
                        <Select
                            optionname="ProgramPrice_ticket_type"
                            name="ticket_type"
                            value={this.props.values.ticket_type}
                            label="Típus"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("ticket_type")}
                        />
                    </div>*/}
                </div>
            </form>
        );
    }
}

export default createForm(ProgramPriceForm);
